module.exports = function() {
  return new Worker(__webpack_public_path__ + "static/json-loader.worker.14e7.js");
};